import React, { useState } from 'react';
import {
Table,
TableBody,
TableCell,
TableContainer,
TableHead,
TableRow,
Typography,
Box,
IconButton,
Modal,
Button,
Paper,
Tooltip
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from 'react-router-dom';
import { deleteBeneficiaryUserAction, deleteBenficiaryRelationAction } from '../APIs/action';
import { toast } from 'react-toastify';

const BenefitTable = ({ data, getBenefitBeneficiaryData }) => {
    const navigate = useNavigate();
    const [selectedEntity, setSelectedEntity] = useState(null);
    const [open, setOpen] = useState(false);
    const [confirmationOpen, setConfirmationOpen] = useState(false);
    const [isNominee, setIsNominee] = useState(false);
    const [insuranceType, setInsuranceType] = useState('');
    const [beneficiaryId, setBeneficiaryId] = useState();
    const [isNomineeEmpty, setIsNomineeEmpty ] = useState(false)
    const [deleteType, setDeleteType] = useState(null);

    const handleEditBeneficiary = (entity, isNominee = false, beneficiary = null, index) => {
        navigate('/my-benefits/beneficiary-details', { 
            state: { 
                beneficiary: isNominee ? beneficiary : entity,
                nominee: isNominee ? entity : null,
                isNominee,
                scrollTo: isNominee ? 'nominee-section' : '',
                NomineeIndex : index
            }
        });
    };
    const renderNomineeDetails = (nomineeDetails, beneficiary, benefitKey) => {
        const nomineesArray = Array.isArray(nomineeDetails) ? nomineeDetails : Object.values(nomineeDetails);
        return nomineesArray.map((nominee, index) => (
            <Box key={index} display="flex" alignItems="center">
                <Typography variant="subtitle2">
                    {nominee.first_name} {nominee.last_name}
                </Typography>
                <Tooltip title="Edit">
                    <IconButton
                        size="small"
                        sx={{ ml: 2, '&:hover': { color: 'primary.main', bgcolor: 'action.hover' } }}
                        onClick={() => handleEditBeneficiary(nominee, true, beneficiary, index)}
                    >
                        <EditIcon fontSize="small" />
                    </IconButton>
                </Tooltip>
                <Tooltip title="Delete">
                    <IconButton
                        size="small"
                        sx={{ ml: 2, '&:hover': { color: 'error.main', bgcolor: 'action.hover' } }}
                        onClick={() => handleOpenDeleteModal(beneficiary, nominee, true, benefitKey, beneficiary.beneficiary_details.id)}
                    >
                        <DeleteIcon fontSize="small" />
                    </IconButton>
                </Tooltip>
                
            </Box>
        ));
    };
    const handleOpenDeleteModal = (beneficiary, entity, isNominee, insurance, beneficiaryId) => {
        setIsNominee(isNominee);
        setInsuranceType(insurance);
        setBeneficiaryId(beneficiaryId);
        setSelectedEntity(isNominee ? { ...entity, isNominee } : { ...entity });
        setOpen(true);
        setIsNomineeEmpty(beneficiary.nominee_details.length === 0)
    };
    const handleCancel = () => {
        setOpen(false);
        setConfirmationOpen(false);
    };
    const handleDelete = async () => {
        if (deleteType === 'relation') {
            const payload = {
                beneficiary_id: beneficiaryId,
                nominee_id: isNominee ? selectedEntity?.id : null,
                benefit_type: insuranceType,
            };
            const { error, message } = await deleteBenficiaryRelationAction(payload);
            if (!error) {
                toast.success('Beneficiary Relation Deleted Successfully');
                getBenefitBeneficiaryData();
            } else {
                toast.error(message);
            }
        } else if (deleteType === 'user') {
            const { error, message } = await deleteBeneficiaryUserAction(selectedEntity?.id);
            if (!error) {
                toast.success('Deleted User Successfully');
                getBenefitBeneficiaryData();
            } else {
                toast.error(message);
            }
        }
        setConfirmationOpen(false);
        setOpen(false);
    };
    const renderBeneficiaryRows = (beneficiaries, benefitKey) => {
        return beneficiaries.map((beneficiary, index) => (
            <React.Fragment key={index}>
                <TableRow
                    sx={{
                        '&:last-child td, &:last-child th': { border: 0 },
                    }}
                >
                    {index === 0 && (
                        <TableCell
                            rowSpan={beneficiaries.length}
                        >
                            {benefitKey}
                        </TableCell>
                    )}
                    <TableCell>
                        <Box display="flex" alignItems="center">
                            <Typography variant="subtitle2" sx={{ marginRight: 1 }}>
                                {beneficiary.beneficiary_details.first_name}{' '}
                                {beneficiary.beneficiary_details.last_name}
                            </Typography>
                            <IconButton
                                size="small"
                                sx={{ ml: 2, '&:hover': { color: 'primary.main', bgcolor: 'action.hover' } }}
                                onClick={() => handleEditBeneficiary(beneficiary)}
                            >
                                <EditIcon fontSize="small" />
                            </IconButton>
                            <IconButton
                                size="small"
                                sx={{ ml: 2, '&:hover': { color: 'error.main', bgcolor: 'action.hover' } }}
                                onClick={() => handleOpenDeleteModal(beneficiary, beneficiary.beneficiary_details, false, benefitKey, beneficiary.beneficiary_details.id)}
                            >
                                <DeleteIcon fontSize="small" />
                            </IconButton>
                        </Box>
                    </TableCell>
                    <TableCell>
                        {renderNomineeDetails(beneficiary.nominee_details, beneficiary, benefitKey)}
                    </TableCell>
                </TableRow>
            </React.Fragment>
        ));
    };

    return (
        <>
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="beneficiary table">
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ backgroundColor: '#d9d9d94d', color: 'common.black', fontWeight: 'bold' }}>Benefit</TableCell>
                            <TableCell sx={{ backgroundColor: '#d9d9d94d', color: 'common.black' , fontWeight: 'bold' }}>Beneficiary Details</TableCell>
                            <TableCell sx={{ backgroundColor: '#d9d9d94d', color: 'common.black' , fontWeight: 'bold' }}>Nominee Details</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data && Object.keys(data).map((benefitKey) => (
                            <React.Fragment key={benefitKey}>
                                {renderBeneficiaryRows(data[benefitKey], benefitKey)}
                            </React.Fragment>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            
            {/* Delete Modal */}
            <Modal  
                open={open}
                onClose={handleCancel}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 400,
                    bgcolor: 'background.paper',
                    border: '2px solid #000',
                    boxShadow: 24,
                    p: 4,
                }}>
                    <Typography sx={{ fontSize: 'bold', textAlign: 'center', marginBottom: 2 }} component="h2">
                        You Want to Delete?
                    </Typography>
                    <Box sx={{ mt: '2rem', display: 'flex', alignContent: 'center', justifyContent: 'center' }}>
                        <Button
                            variant="contained"
                            color="primary"
                            fullWidth
                            sx={{ marginRight: 2 }}
                            onClick={() => {
                                setConfirmationOpen(true);
                                setDeleteType('user');
                            }}
                        >
                            User
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            fullWidth
                            sx={{ marginRight: 2 }}
                            onClick={() => {
                                setConfirmationOpen(true);
                                setDeleteType('relation');
                            }}
                        >
                            Relation
                        </Button> 
                    </Box>
                </Box>
            </Modal>

            {/* Confirmation Modal */}
            <Modal
                open={confirmationOpen}
                onClose={handleCancel}
                aria-labelledby="confirmation-modal-title"
                aria-describedby="confirmation-modal-description"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 300,
                    bgcolor: 'background.paper',
                    border: '2px solid #000',
                    boxShadow: 24,
                    p: 4,
                }}>
                    <Typography sx={{ fontSize: 'bold', textAlign: 'center', marginBottom: 2 }} component="h2">
                        If you Delete the {deleteType === 'user' ? 'user all data of user will be removed' : 'relation, user will be removed from selected benefit'}?
                    </Typography>
                    <Box sx={{ mt: '2rem', display: 'flex', alignContent: 'center', justifyContent: 'center' }}>
                        <Button
                            variant="contained"
                            color="error"
                            sx={{ marginRight: 2 }}
                            onClick={handleDelete}
                        >
                            Confirm
                        </Button>
                        <Button
                            variant="contained"
                            color="secondary"
                            sx={{ marginRight: 2 }}
                            onClick={handleCancel}
                        >
                            Cancel
                        </Button>
                    </Box>
                </Box>
            </Modal>
        </>
    );
};

export default BenefitTable;
